/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "priority",
            "endpoint": "https://jpxdi4c33m.execute-api.us-east-2.amazonaws.com/production",
            "region": "us-east-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-2:3eb1c0eb-68b6-4ec1-bb9b-12a7bcfa8929",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_PVib1tZL7",
    "aws_user_pools_web_client_id": "2li6b62bjbrfgk7p2dtquv0njp",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "usersv2-production",
            "region": "us-east-2"
        }
    ],
    "aws_mobile_analytics_app_id": "cea6d73c52ac4f0fb34edf56fd8b54c2",
    "aws_mobile_analytics_app_region": "us-east-1"
};


export default awsmobile;
